import {
    CHANGE_FONT_SIZE,
    SET_GAME_SETTINGS,
    TOGGLE_AUDIO,
    TOGGLE_TIMED_GAMES,
} from '../constants/actions';

export const setGameSettings = (difficulty, party, importantIssue) => {
    const failThreshold =
        difficulty === 'hard' ? -20 : difficulty === 'medium' ? -25 : -30;
    return {
        type: SET_GAME_SETTINGS,
        gameSettings: {
            difficulty,
            party,
            importantIssue,
            failThreshold,
        },
    };
};

export const changeFontSize = fontSize => {
    return {
        type: CHANGE_FONT_SIZE,
        fontSize,
    };
};

export const toggleAudio = boolean => {
    return {
        type: TOGGLE_AUDIO,
        boolean,
    };
};

export const toggleTimedGames = boolean => {
    return {
        type: TOGGLE_TIMED_GAMES,
        boolean,
    };
};
